import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import order from './modules/order'
import getters from './getters'
import ws from './ws'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    order,
    ws
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js